import { render, staticRenderFns } from "./partner-summary.vue?vue&type=template&id=5c8decd0&scoped=true"
import script from "./partner-summary.vue?vue&type=script&lang=js"
export * from "./partner-summary.vue?vue&type=script&lang=js"
import style0 from "./partner-summary.vue?vue&type=style&index=0&id=5c8decd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8decd0",
  null
  
)

export default component.exports